module.exports = __webpack_public_path__ + "static/media/home-office-336377_1920.f162d915.jpg";